import { render, staticRenderFns } from "./KpiBarWidget.vue?vue&type=template&id=39609481&scoped=true"
import script from "./KpiBarWidget.vue?vue&type=script&lang=js"
export * from "./KpiBarWidget.vue?vue&type=script&lang=js"
import style0 from "./KpiBarWidget.vue?vue&type=style&index=0&id=39609481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39609481",
  null
  
)

export default component.exports